export const DEFAULT_ABOUT_PAGE_NAME_PREFIX = "Untitled Page";

export const getDefaultAboutPageName = (index: number) => `${DEFAULT_ABOUT_PAGE_NAME_PREFIX} ${index}`;

export const isDefaultAboutPageName = (name: string) => name.startsWith(`${DEFAULT_ABOUT_PAGE_NAME_PREFIX} `);
